import React from 'react';
import { motion } from 'framer-motion';
import { ShieldIcon, GripIcon, LightbulbIcon, Rotate3dIcon } from 'lucide-react';
export function SpecsSection() {
  const specs = [{
    icon: ShieldIcon,
    title: 'Material',
    desc: 'High-durability, heat-resistant polymer'
  }, {
    icon: GripIcon,
    title: 'Grip',
    desc: 'Quad-suction technology (works on glass, plastic, and polished wood)'
  }, {
    icon: LightbulbIcon,
    title: 'Light',
    desc: 'Eye-safe warm LED (battery-efficient)'
  }, {
    icon: Rotate3dIcon,
    title: 'Flexibility',
    desc: '360-degree limb rotation'
  }];
  return <section className="py-12" data-id="element-155">
      <h2 className="text-2xl font-bold text-center text-white mb-8" data-id="element-156">
        Technical Specs
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-157">
        {specs.map((spec, idx) => <motion.div key={idx} initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: idx * 0.1
      }} className="flex items-start gap-4 p-4 rounded-xl bg-brand-card/50 border border-white/5" data-id="element-158">
            <div className="p-2 bg-brand-dark rounded-lg text-brand-gold shrink-0" data-id="element-159">
              <spec.icon className="w-5 h-5" data-id="element-160" />
            </div>
            <div data-id="element-161">
              <h4 className="text-white font-bold text-sm mb-1" data-id="element-162">
                {spec.title}
              </h4>
              <p className="text-brand-muted text-sm" data-id="element-163">{spec.desc}</p>
            </div>
          </motion.div>)}
      </div>
    </section>;
}